import React, { Component } from "react";
import PropTypes from "prop-types";

export default class FieldBase extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    required: PropTypes.bool,
    submitted: PropTypes.bool,
    value: PropTypes.any,
  };
  render() {
    return (
      <div className="field">
        <div className="question pad-half--bottom">{this.props.title}</div>
        <div className="">{this.props.children}</div>
        {this.props.required &&
          this.props.submitted &&
          (this.props.value === null ||
            this.props.value === "" ||
            this.props.values?.length === 0) && (
            <div className="push-half--left error-message">
              Please answer this question.
            </div>
          )}
      </div>
    );
  }
}
